import StyledBadge from 'components/NavBar/StyledBadge'
import { alpha } from '@mui/material/styles'
import { Avatar, Box, ListItem } from '@mui/material'
import { GetActivityColor, GetActivityText, getStatusAvatar } from 'components/common/activitySelector'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'

const WellRow = ({ row, style, onSelect, selected }) => {
  const { theme, getTextColor } = useInnovaTheme()

  return (
    <ListItem disableGutters style={style} sx={{ px: 1, py: 0.75 }}>
      <Box
        onClick={(e) => onSelect(e, row)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          px: 2,
          py: 1,
          borderRadius: 2,
          border: selected ? '1px solid green' : '2px solid transparent',
          background: selected
            ? alpha(getTextColor(), theme === 'dark' ? 0.18 : 0.12)
            : alpha(getTextColor(), theme === 'dark' ? 0.05 : 0.03),
          transition: 'all 0.18s ease',
          cursor: 'pointer',

          '&:hover': {
            background: alpha(getTextColor(), theme === 'dark' ? 0.1 : 0.06),
          },
        }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: alpha(getTextColor(), 0.35),
            flexShrink: 0,
          }}>
          <StyledBadge
            badgecolor={GetActivityColor(row.wellStatus)}
            badgeContent={GetActivityText(row.wellStatus)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Avatar alt='Well Icon' src={getStatusAvatar(row.wellStatus)} sx={{ width: 34, height: 34 }} />
          </StyledBadge>
        </Box>

        <Box
          sx={{
            ml: 2.5,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            overflow: 'hidden',
            minWidth: 0,
          }}>
          <Box
            sx={{
              fontWeight: 600,
              fontSize: 15,
              color: getTextColor(),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {row.actualWell}
          </Box>

          <Box
            sx={{
              fontSize: 13,
              mt: 0.6,
              color: alpha(getTextColor(), 0.65),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {row.operator}
          </Box>

          <Box
            sx={{
              fontSize: 12,
              mt: 0.4,
              color: alpha(getTextColor(), 0.45),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {`${row.jobNum} • ${row.state}/${row.county}`}
          </Box>
          <Box
            sx={{
              fontSize: 12,
              mt: 0.4,
              color: alpha(getTextColor(), 0.45),
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {`${row.organization} • ${row.rig}`}
          </Box>
        </Box>
      </Box>
    </ListItem>
  )
}

export default WellRow
